/**
 * @module 易借宝相关模块路由
 */
export default [
  {
    path: '/yjb/member',
    name: 'yjb-member',
    component: () => import('@/pages/activity/yjb-app/member/index'),
    meta: { title: '会员' }
  }
]
